import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getPublicNews, getPublicNewsDetail } from '@/lib/cms';

interface Article {
  id: number;
  category: string;
  date: string;
  title: string;
  excerpt: string;
  image: string;
  author: string;
  authorTitle: string;
  readTime: string;
  body: string[];
  tags: string[];
}

const articles: Record<number, Article> = {
  12: {
    id: 12, category: '公司新闻', date: '2026-07-18',
    title: '蚂蚁链控股集团发布「量化驱动资管」核心战略，锚定三大资管板块长期发展路径',
    excerpt: '集团正式明确「量化驱动资管」核心战略定位——以蚂蚁量化为底层策略引擎，以蚂蚁基金、蚂蚁家办、蚂蚁资本为三大资产管理支柱，构建科技驱动型资产管理集团。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20corporate%20strategy%20vision%20roadmap%20with%20glowing%20interconnected%20nodes%20representing%20quantitative%20technology%20flowing%20into%20three%20asset%20management%20pillars%20fund%20management%20family%20office%20capital%20investment%20dark%20navy%20background%20warm%20gold%20and%20amber%20accent%20lines%20professional%20sophisticated%20dark%20fintech%20aesthetic%20visionary%20corporate%20mood%20no%20text%20no%20people&width=1200&height=600&seq=news-detail-12&orientation=landscape',
    author: '集团战略发展部',
    authorTitle: '蚂蚁链控股集团',
    readTime: '8 分钟',
    tags: ['核心战略', '量化驱动资管', '资产管理', '集团定位', '战略发布'],
    body: [
      '2026年7月18日，香港——蚂蚁链控股集团（"蚂蚁链控集团"或"集团"）今日正式发布「量化驱动资管」核心战略白皮书，首次以集团战略文件的形式明确了"以量化科技为底层策略引擎、以资产管理为核心业务主题"的长期发展定位。此次战略发布是集团继海外全球化布局、组织架构公开之后的又一重大里程碑，标志着蚂蚁链控集团从业务扩张阶段正式迈入战略品牌化运营的新周期。',

      '白皮书开篇即指出：「量化是蚂蚁链控集团的方法论基因，资产管理是蚂蚁链控集团的商业本质。二者并非并行关系，而是底层驱动与上层表达的有机统一体。」这一表述从根本上厘清了集团旗下各业务板块之间的逻辑关系——蚂蚁量化不是一项独立业务，而是贯穿蚂蚁基金、蚂蚁家办与蚂蚁资本三大资产管理板块的策略引擎与技术底座。',

      '在"量化驱动资管"的战略框架下，集团被划分为一个清晰的"1+3"架构。其中"1"代表蚂蚁量化——作为集团的中央策略引擎，负责多因子模型研发、另类数据挖掘、机器学习算法优化与实时风控体系构建，为三大资管板块提供统一的策略输出与技术支撑。"3"则代表蚂蚁基金、蚂蚁家办与蚂蚁资本三大资产管理业务板块，分别面向不同客户群体与资产类别，依托蚂蚁量化的策略输出，开展差异化的资产管理服务。',

      '具体来看，蚂蚁基金定位为"量化驱动的基金研究与资产配置管理平台"，面向机构投资者与高净值个人客户，提供涵盖公募基金FOF、私募基金组合管理与定制化专户资管在内的一站式资产配置服务。在"量化驱动资管"战略下，蚂蚁基金将深度整合蚂蚁量化的因子模型与宏观情绪指标，构建新一代智能投顾与动态资产配置系统。',

      '蚂蚁家办定位为"量化赋能的家族资产管理平台"，面向亚太区超高净值家族客户，提供跨代财富规划、家族信托架构、跨境税务优化与全球资产配置等综合服务。战略白皮书特别强调，蚂蚁家办将率先引入蚂蚁量化的风险管理模型与情景分析引擎，为家族客户构建"量化风控+人本服务"双轮驱动的家族资产管理体系。',

      '蚂蚁资本定位为"量化增强的另类资产管理平台"，聚焦私募股权投资、并购重组与结构化融资领域。战略文件指出，蚂蚁资本将在项目筛选、估值建模与退出时机判断等关键环节全面引入蚂蚁量化的行业轮动模型与宏观周期分析框架，以数据驱动的方式提升投资决策的科学性与成功率。',

      '白皮书进一步阐述了"量化驱动资管"战略的三大支柱原则：第一，技术先行——量化策略研发必须走在业务需求前面，始终保持策略库的前瞻性与多样性；第二，合规为本——所有量化模型与资管产品必须在SFC第9类牌照监管框架内运行，合规是量化创新不可逾越的底线；第三，客户中心——量化技术的最终价值在于为客户创造可持续的资产管理回报，而非追求技术本身的复杂度。',

      '集团主席兼首席执行官白子晨在战略发布会上表示：「蚂蚁链控集团从创立第一天起，就在用数据科学的方法做资产管理。过去几年我们在量化研究上投入了巨大的资源，不是因为量化是一个热门的赛道，而是因为我们深信——在信息高度不对称的全球资本市场中，系统化的量化方法是为客户创造确定性回报的最可靠路径。今天发布『量化驱动资管』战略，不是一次品牌包装，而是把我们一直在做的事情讲清楚、讲透。」',

      '白子晨进一步指出，未来三年集团将围绕"量化驱动资管"战略实施三大重点工程：第一，加大蚂蚁量化在另类数据与人工智能领域的研发投入，力争在亚太区量化策略研究领域建立领先优势；第二，推动蚂蚁基金、蚂蚁家办与蚂蚁资本三大板块之间的策略协同与客户资源共享，打造"一个集团、统一策略、三个入口"的资管服务体系；第三，持续完善合规与风控基础设施，确保在量化模型复杂度不断提升的背景下，集团的合规标准只升不降。',

      '业内分析人士对此次战略发布给予了高度关注。多位资产管理行业资深人士表示，蚂蚁链控集团将量化科技与资产管理进行战略层面的绑定，在亚太区金融科技领域具有相当的独特性。相比市场上多数将量化视为独立业务线或单一策略产品的机构，蚂蚁链控集团的"量化驱动资管"模式在业务逻辑上更为自洽——量化不是被销售的策略，而是驱动资产管理的核心能力。',

      '据悉，集团计划于2026年第四季度举办首届"量化驱动资管"年度峰会，届时将邀请全球量化金融与资产管理领域的顶尖学者、机构投资者与监管机构代表，共同探讨量化技术在资产管理行业的前沿应用与监管演进。此次峰会被视为蚂蚁链控集团在"量化驱动资管"战略发布后的首次行业级品牌亮相。',

      '战略白皮书全文已在集团官网投资者关系板块同步上线，供合作伙伴、客户与行业同仁下载阅览。白皮书以中英双语发布，全面阐述了蚂蚁链控集团对量化投资与资产管理行业未来趋势的判断，以及集团在"量化驱动资管"战略框架下的具体实施路径与阶段性目标。',
    ],
  },
  1: {
    id: 1, category: '公司新闻', date: '2026-06-20',
    title: '蚂蚁链控股集团与中信证券国际达成战略合作，共建跨境量化交易平台',
    excerpt: '双方将在跨境量化策略研发、数据共享与风控技术等领域展开深度合作，共同推动大中华区量化投资生态建设。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20business%20partnership%20visualization%2C%20dark%20navy%20and%20gold%20abstract%20elements%2C%20financial%20data%20overlay%2C%20clean%20sophisticated%20style%2C%20dark%20atmosphere%2C%20no%20text&width=1200&height=600&seq=news-detail-01&orientation=landscape',
    author: '集团新闻中心',
    authorTitle: '蚂蚁链控股集团',
    readTime: '6 分钟',
    tags: ['战略合作', '量化交易', '中信证券', '跨境金融', '金融科技'],
    body: [
      '2026年6月20日，香港——蚂蚁链控股集团（"蚂蚁链控集团"或"集团"）今日宣布，已与中信证券国际有限公司（"中信证券国际"）正式签署战略合作协议。双方将围绕跨境量化交易平台建设、策略联合研发、数据共享及风控技术等核心领域展开全面合作。',

      '此次战略合作的达成，标志着蚂蚁链控集团在量化研究与金融科技领域的布局迈入全新阶段。中信证券国际作为中信证券的全资境外子公司，拥有覆盖全球主要资本市场的交易执行能力与丰富的机构客户资源。蚂蚁链控集团则将依托其在多因子模型、机器学习算法及另类数据处理等领域的技术积累，为合作注入领先的量化研究能力。',

      '根据协议，双方将共同投资建设一个面向大中华区机构投资者的跨境量化交易平台。该平台将整合双方在数据接入、策略回测、交易执行与实时风控等环节的技术优势，为客户提供从策略研发到交易执行的一站式量化解决方案。',

      '蚂蚁链控股集团主席兼首席执行官白子晨表示："与中信证券国际的战略合作，是蚂蚁链控集团「科技赋能金融」使命的又一重要里程碑。中信证券国际在跨境交易执行与机构服务方面的深厚积淀，与我们在量化研究领域的前沿技术形成了完美互补。我们期待通过此次合作，为大中华区投资者打造一个真正世界级的量化交易基础设施。"',

      '中信证券国际首席执行官表示："蚂蚁链控集团在量化研究与金融科技领域的创新能力令人印象深刻。此次合作将进一步提升我们在量化交易领域的服务能力，为客户创造更大的价值。我们相信，通过双方的深度协作，能够共同推动大中华区量化投资生态的升级与繁荣。"',

      '据悉，跨境量化交易平台预计将于2026年第四季度进入试运营阶段，首批将覆盖港股、A股（沪深港通）及美股三大核心市场，支持多因子选股、统计套利、CTA趋势跟踪及事件驱动等主流策略类型的研发与执行。平台还将引入蚂蚁链控集团自主研发的实时风控引擎，确保交易执行的全流程合规与风险可控。',

      '此外，双方还计划联合设立"量化策略创新实验室"，共同开展前沿量化策略的学术研究与产业应用转化。实验室将聚焦人工智能在量化投资中的深度应用、另类数据信号挖掘、以及跨境市场微观结构研究等前沿课题。',

      '此次战略合作的消息发布后，获得了市场的广泛关注。多位业内人士表示，蚂蚁链控集团与中信证券国际的强强联合，有望为大中华区量化投资行业带来新一轮的技术升级与生态变革。',
    ],
  },
  2: {
    id: 2, category: '行业洞察', date: '2026-06-15',
    title: '2026年下半年全球宏观展望：利率拐点下的资产配置新范式',
    excerpt: '蚂蚁基金研究团队发布最新宏观研究报告，深入分析美联储政策路径、亚太市场机遇与多资产配置策略。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20global%20macroeconomic%20analysis%2C%20world%20map%20data%20nodes%20in%20dark%20navy%2C%20gold%20accents%2C%20professional%20research%20aesthetic%2C%20dark%20mood%2C%20no%20text&width=1200&height=600&seq=news-detail-02&orientation=landscape',
    author: '蚂蚁基金研究团队',
    authorTitle: '蚂蚁链控股集团 · 研究部',
    readTime: '12 分钟',
    tags: ['宏观展望', '资产配置', '利率政策', '亚太市场', '投资策略'],
    body: [
      '随着2026年步入下半程，全球经济格局正经历深刻重塑。美联储在经历长达两年的加息周期后，政策利率已逐步进入平台期，市场普遍预期下半年将迎来首次降息窗口。在此背景下，全球资产配置的逻辑正在发生根本性变化。蚂蚁基金研究团队基于对全球宏观经济的系统性分析，发布2026年下半年全球宏观展望报告。',

      '报告指出，三大核心变量将主导下半年的全球资产定价：第一，美联储政策路径的节奏与幅度——目前市场定价已隐含年内两次25个基点的降息预期，但实际路径仍高度依赖通胀与就业数据的演变；第二，亚太区经济复苏的结构性分化——日本央行正常化进程、中国稳增长政策力度、以及东盟制造业转移带来的增长红利，正在重塑区域资金流向；第三，地缘政治风险的定价——从大国博弈到供应链重构，尾部风险溢价正在成为资产配置中不可忽视的变量。',

      '在资产配置策略方面，报告建议投资者采取"杠铃策略"：一端配置高质量固定收益资产以锁定当前较高的票息收益，另一端精选权益市场中被低估的优质成长标的。具体而言，在固收端，投资级美元信用债与亚洲高评级本币债在收益率与风险调整后回报方面具有较强吸引力；在权益端，亚太区科技创新、绿色能源转型与消费升级三大主题值得重点关注。',

      '报告还强调了另类资产在组合中的战略价值。随着传统股债相关性的波动加剧，私募股权、基础设施投资、以及量化对冲策略的配置价值正在凸显。蚂蚁基金的量化研究团队发现，在当前宏观环境下，多因子模型中加入宏观情绪因子与流动性因子后，策略的夏普比率平均可提升0.3至0.5个点。',

      '对于亚太市场，报告持建设性观点。香港作为连接内地与全球资本市场的超级联系人，其金融基础设施的持续升级与产品创新为投资者提供了丰富的配置工具。同时，东南亚新兴市场在人口红利与产业转移的双重驱动下，中长期增长潜力值得期待。',
    ],
  },
  3: {
    id: 3, category: '合规学习', date: '2026-06-10',
    title: '蚂蚁链控股集团完成SFC第9类牌照年度合规审查',
    excerpt: '集团旗下持牌主体顺利通过香港证监会年度审查，合规管理体系获监管机构高度认可。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20compliance%20regulatory%20visualization%2C%20shield%20pattern%20with%20checkmark%2C%20dark%20navy%20background%2C%20gold%20accents%2C%20trustworthy%20corporate%20mood%2C%20dark%20atmosphere%2C%20no%20text&width=1200&height=600&seq=news-detail-03&orientation=landscape',
    author: '集团合规部',
    authorTitle: '蚂蚁链控股集团',
    readTime: '4 分钟',
    tags: ['合规审查', 'SFC牌照', '监管合规', '风险管理'],
    body: [
      '2026年6月10日，香港——蚂蚁链控股集团今日宣布，集团旗下持牌主体已顺利通过香港证券及期货事务监察委员会（SFC）第9类（提供资产管理）牌照的年度合规审查。此次审查结果的优异表现，充分体现了集团在合规管理与风险控制方面的一流水平。',

      '本次年度审查覆盖了集团持牌主体的公司治理、内部监控、风险管理、客户资产保护、反洗钱与反恐融资、以及业务操守等全部核心领域。SFC审查团队对集团的合规管理体系建设给予了高度评价，尤其是在数字化合规监控系统与实时风控预警机制方面的创新实践。',

      '集团首席风险官张国强表示："合规是蚂蚁链控集团的生命线。我们一直将合规管理视为核心竞争力的重要组成部分。此次顺利通过SFC年度审查，是集团合规团队长期努力的结果，也体现了我们在持牌运营方面的专业水准。"',

      '据悉，蚂蚁链控集团已建立了涵盖事前预防、事中监控与事后审查的全流程合规管理体系。集团自主研发的合规科技平台能够实现对交易行为、投资限制与风险敞口的实时监控与自动化预警，大幅提升了合规管理的效率与精准度。',
    ],
  },
  4: {
    id: 4, category: '市场研究', date: '2026-06-05',
    title: '量化策略月报：多因子模型在震荡市中的表现与优化',
    excerpt: '蚂蚁量化研究团队发布6月策略月报，回顾各策略线表现，分析因子轮动规律与模型优化方向。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20quantitative%20research%20report%20with%20candlestick%20charts%20and%20data%20analysis%2C%20dark%20navy%20background%2C%20blue%20and%20gold%20geometric%20elements%2C%20professional%20dark%20fintech%20style%2C%20no%20text&width=1200&height=600&seq=news-detail-04&orientation=landscape',
    author: '蚂蚁量化研究团队',
    authorTitle: '蚂蚁链控股集团 · 量化研究部',
    readTime: '10 分钟',
    tags: ['量化策略', '多因子模型', '因子轮动', '月度报告'],
    body: [
      '蚂蚁量化研究团队发布2026年6月策略月报，系统回顾了各策略线在过去一个月中的表现，并深入分析了因子轮动规律与模型优化方向。本报告涵盖多因子选股、统计套利、CTA趋势跟踪及事件驱动四大核心策略线。',

      '在回顾期内，全球权益市场呈现震荡分化的格局。多因子选股策略凭借价值因子与质量因子的双重暴露，在震荡市中实现了稳健的超额收益。统计套利策略在波动率抬升的环境中捕捉到了丰富的套利机会，月内胜率与盈亏比均处于历史较高水平。',

      '报告重点分析了因子轮动的最新规律。研究发现，在当前宏观环境下，低波动因子与质量因子的风险调整后表现显著优于动量和成长因子。这一轮动特征与全球利率环境的不确定性高度相关——投资者在政策拐点期更偏好确定性较高的因子暴露。',

      '在模型优化方面，研究团队引入了基于深度学习的宏观情绪因子，将新闻情绪、政策信号与市场微观结构数据融合到现有的多因子框架中。回测结果显示，优化后的模型在信息比率与最大回撤控制两项指标上均有显著改善。',
    ],
  },
  5: {
    id: 5, category: '公告', date: '2026-05-28',
    title: '关于蚂蚁链控股集团官方网站全新上线的公告',
    excerpt: '为更好展示集团品牌形象与业务体系，集团官方网站于2026年5月完成全面升级，正式上线运营。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20website%20launch%20announcement%2C%20abstract%20digital%20network%2C%20dark%20navy%20background%2C%20gold%20accent%20elements%2C%20clean%20sophisticated%20dark%20corporate%20style%2C%20no%20text&width=1200&height=600&seq=news-detail-05&orientation=landscape',
    author: '集团品牌与数字化部',
    authorTitle: '蚂蚁链控股集团',
    readTime: '3 分钟',
    tags: ['官网升级', '品牌形象', '数字化转型'],
    body: [
      '2026年5月28日，香港——蚂蚁链控股集团今日宣布，集团官方网站已完成全面升级，正式上线运营。新版官网以"科技赋能金融，连接全球资产价值"为设计理念，全面展现了集团的品牌形象、业务体系与发展愿景。',

      '此次官网升级是集团品牌战略的重要组成部分。新版网站采用国际领先的设计语言与用户体验标准，在视觉呈现、信息架构与交互体验三大维度实现了全面革新。网站全面展示了集团旗下量化研究、基金管理、家族办公室与资本服务四大核心业务板块，同时设有新闻动态、合规学习与研究洞察等内容专区。',

      '集团主席兼首席执行官白子晨表示："官方网站是蚂蚁链控集团面向全球客户与合作伙伴的第一窗口。我们希望通过全新的数字形象，更加准确、生动地传达蚂蚁链控集团的品牌理念与价值主张。这也标志着我们在数字化转型道路上又迈出了坚实的一步。"',
    ],
  },
  6: {
    id: 6, category: '公司新闻', date: '2026-05-20',
    title: '蚂蚁家办成功举办"家族财富传承与跨境税务规划"高端闭门研讨会',
    excerpt: '来自香港、新加坡与内地的多位家族办公室负责人及税务专家齐聚一堂，深入探讨跨境财富传承新趋势。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20seminar%20and%20conference%20scene%2C%20sophisticated%20dark%20venue%20atmosphere%2C%20dark%20navy%20and%20gold%20theme%2C%20professional%20abstract%20representation%2C%20dark%20mood%2C%20no%20text&width=1200&height=600&seq=news-detail-06&orientation=landscape',
    author: '蚂蚁家办',
    authorTitle: '蚂蚁链控股集团 · 家族办公室',
    readTime: '5 分钟',
    tags: ['家族办公室', '财富传承', '税务规划', '闭门研讨会'],
    body: [
      '2026年5月20日，香港——由蚂蚁家族办公室主办的"家族财富传承与跨境税务规划"高端闭门研讨会于香港四季酒店成功举办。来自香港、新加坡与内地的三十余位家族办公室负责人、顶级税务规划师及私人银行家齐聚一堂，围绕跨境财富传承的最新趋势与实操策略进行了深入探讨。',

      '研讨会设置了三大核心议题：全球税务透明化背景下的合规架构设计、跨境家族信托的最新实践、以及新一代家族成员治理与接班人培养。与会嘉宾结合真实案例，分享了在不同司法管辖区进行财富规划的前沿经验。',

      '蚂蚁家办负责人表示："随着全球税务合规要求的不断提升，家族财富传承规划的复杂性与专业性要求也在持续升级。作为扎根香港、服务亚太的领先家办平台，我们致力于整合全球顶级专业资源，为家族客户提供全方位、定制化的传承解决方案。"',
    ],
  },
  7: {
    id: 7, category: '行业洞察', date: '2026-05-15',
    title: '区块链技术在资产管理领域的应用前景与合规挑战',
    excerpt: '蚂蚁链控集团研究团队发布专题报告，系统梳理区块链技术在资产代币化、智能合约与合规监管领域的应用现状。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20blockchain%20network%20visualization%2C%20interconnected%20nodes%20and%20chains%2C%20dark%20navy%20background%2C%20blue%20and%20gold%20geometric%20elements%2C%20futuristic%20dark%20fintech%20style%2C%20no%20text&width=1200&height=600&seq=news-detail-07&orientation=landscape',
    author: '蚂蚁链控集团研究团队',
    authorTitle: '蚂蚁链控股集团 · 研究部',
    readTime: '8 分钟',
    tags: ['区块链', '资产管理', '合规监管', '金融科技'],
    body: [
      '蚂蚁链控集团研究团队发布专题报告，系统梳理了区块链技术在资产管理领域的应用前景与合规挑战。报告指出，随着全球主要金融中心加速推进数字资产监管框架的完善，区块链技术在传统资产管理领域的应用正从概念验证阶段迈入实质性落地阶段。',

      '报告分析了三大核心应用场景：第一，资产代币化——将传统非流动性资产（如私募股权、房地产与艺术品）通过区块链技术分割为可交易的数字代币，从而提升资产的流动性与可及性；第二，智能合约驱动的自动化运营——利用智能合约实现基金认购、赎回、费用计算与收益分配的全流程自动化，大幅降低运营成本与操作风险；第三，分布式账本提升合规透明度——通过不可篡改的链上记录，实现实时监管报告与审计追溯。',

      '在合规挑战方面，报告指出了跨境监管协调、投资者适当性管理、托管安排以及反洗钱合规等关键议题。尤其是在香港、新加坡等积极推动数字资产监管创新的司法管辖区，持牌机构需要在创新与合规之间找到精准的平衡点。',
    ],
  },
  8: {
    id: 8, category: '合规学习', date: '2026-05-08',
    title: '香港证监会最新《基金经理操守准则》修订要点解读',
    excerpt: '集团合规团队发布政策解读，梳理SFC最新修订对资产管理公司运营与合规管理的具体影响与应对措施。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20legal%20document%20review%20visualization%2C%20regulatory%20compliance%20theme%2C%20dark%20navy%20background%2C%20clean%20dark%20corporate%20style%2C%20abstract%20representation%2C%20no%20text&width=1200&height=600&seq=news-detail-08&orientation=landscape',
    author: '集团合规部',
    authorTitle: '蚂蚁链控股集团',
    readTime: '7 分钟',
    tags: ['SFC', '基金经理操守准则', '合规解读'],
    body: [
      '香港证监会于2026年4月发布了最新修订的《基金经理操守准则》，对资产管理公司的运营管理提出了更加细化的要求。蚂蚁链控集团合规团队第一时间组织了专题研究，并发布政策解读报告，帮助业内同仁全面理解修订要点与应对策略。',

      '本次修订的核心变化集中在三个方面：第一，强化了对利益冲突管理的具体要求，要求基金管理人在投资决策、交易执行与费用收取等环节建立更加严格的防火墙机制；第二，新增了关于环境、社会及管治（ESG）因素的整合要求，明确要求基金管理人在投资流程中系统性地考虑ESG风险与机遇；第三，提升了对客户信息披露的透明度标准，包括费用结构、业绩基准与风险指标等关键信息的披露要求。',

      '集团合规团队建议持牌机构应从制度建设、流程优化与系统升级三个维度着手，确保在新规生效前完成全面合规改造。蚂蚁链控集团已率先启动了内部合规升级项目，预计将在新规正式实施前完成全部改造工作。',
    ],
  },
  9: {
    id: 9, category: '市场研究', date: '2026-04-28',
    title: '亚太区家族办公室发展趋势：从财富保值到影响力投资',
    excerpt: '蚂蚁家办研究院发布年度白皮书，深入分析亚太区家族办公室在资产配置、治理结构与ESG投资领域的演变趋势。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20family%20office%20wealth%20management%20trend%20report%2C%20dark%20navy%20background%2C%20golden%20heritage%20symbolism%2C%20sophisticated%20dark%20corporate%20style%2C%20no%20text&width=1200&height=600&seq=news-detail-09&orientation=landscape',
    author: '蚂蚁家办研究院',
    authorTitle: '蚂蚁链控股集团 · 家族办公室',
    readTime: '9 分钟',
    tags: ['家族办公室', '影响力投资', 'ESG', '白皮书'],
    body: [
      '蚂蚁家办研究院发布2026年度白皮书《亚太区家族办公室发展趋势：从财富保值到影响力投资》，基于对亚太区超过200家单一家族办公室与联合家族办公室的深度调研，系统分析了区域家办行业的最新演变趋势。',

      '白皮书指出，亚太区家族办公室正在经历从"财富保值"到"价值创造"的范式转移。传统的资产配置以保值增值为核心目标，而新一代家族掌门人更加关注投资的社会影响与可持续发展价值。调研数据显示，超过65%的受访家办已将ESG因素纳入投资决策框架，较三年前提升了近30个百分点。',

      '在资产配置方面，白皮书发现亚太区家办正在显著加大对私募股权、风险投资与直接投资的配置比例。与此同时，影响力投资的崛起正在重塑家办的投资理念——从清洁能源到普惠金融，从教育科技到医疗健康，越来越多的家族资本正在流向具有明确社会价值创造能力的领域。',

      '白皮书还深入分析了家办治理结构的专业化趋势。随着家族财富规模的持续增长与跨代传承需求的日益迫切，越来越多的亚太家族正在建立制度化的投资委员会、家族宪章与接班人培养体系。蚂蚁家办预计，这一专业化趋势将在未来五年内进一步加速。',
    ],
  },
  10: {
    id: 10, category: '公司新闻', date: '2026-07-04',
    title: '香港蚂蚁量化系统组织架构首次公开：覆盖全国的量化服务网络',
    excerpt: '集团首次全面公开「香港蚂蚁量化系统」组织架构，展示从总部到五大区域、七大联合创始人、十八位商学院讲师、三十六位战略委、七十二位分公司老总及一百零八位核心团队长的完整体系。',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20organizational%20structure%20diagram%20visualization%20abstract%20hierarchy%20network%20with%20connected%20nodes%20dark%20navy%20background%20with%20gold%20accents%20professional%20corporate%20style%20clean%20dark%20fintech%20aesthetic%20no%20text&width=1200&height=600&seq=news-detail-10&orientation=landscape',
    author: '集团品牌与数字化部',
    authorTitle: '蚂蚁链控股集团',
    readTime: '5 分钟',
    tags: ['组织架构', '公司新闻', '量化系统', '集团架构', '战略布局'],
    body: [
      '2026年7月4日，香港——蚂蚁链控股集团今日首次全面公开「香港蚂蚁量化系统」组织架构全景图，向外界展示了集团从顶层总部到一线执行团队的完整层级体系与全国布局网络。此次公开不仅是对外展示集团规模实力，更彰显了蚂蚁链控集团在量化金融领域深耕细作、系统化运营的长期战略定力。',

      'IMAGE:https://static.readdy.ai/image/feef753f1ed8344cc3f9a51076258ebd/7b07fefddd74f714dc175490768c683e.jpeg',

      '从组织架构全景图可以看出，蚂蚁链控股集团采取「总部统筹、区域作战、层级分明、专业分工」的运营管理模式。整个体系以香港蚂蚁量化集团总部为核心决策中枢，由集团创始人亲自掌舵战略方向，下辖五大区域战区，覆盖全国所有重点金融市场。',

      '五大区域战区分别是：华南战区（覆盖广东、广西、海南、福建、香港、澳门及深圳、广州、佛山、珠海等核心城市）、华北战区（覆盖北京、天津、河北、山西、内蒙古、辽宁、吉林、黑龙江）、华东战区（覆盖上海、江苏、浙江、安徽、江西、山东、河南、湖北）、西南战区（覆盖四川、重庆、云南、贵州、西藏）以及西北战区（覆盖陕西、甘肃、宁夏、青海、新疆）。这种五大区域划分确保了集团能够快速响应不同地区的市场特征与监管环境，提供定制化的量化投资服务。',

      '在联合创始人层面，集团汇聚了七位联合创始人，他们在量化研究、金融科技、合规风控、资本市场等领域各自拥有深厚的专业积淀与丰富的行业资源。七位联合创始人共同构成了集团的核心决策层，确保集团在快速扩张的同时始终保持专业水准与合规底线。',

      '商学院讲师团队由十八位资深行业专家组成，负责集团内部人才培养与外部客户教育。他们系统性地传授量化投资方法论、风险管理技术与市场分析框架，为集团持续输送高素质的专业人才，同时也帮助客户更好地理解量化策略的逻辑与价值。',

      '战略委员会由三十六位核心成员组成，是集团战略制定与重大决策的参谋机构。战略委成员来自不同的业务条线与市场区域，能够从多维度为集团的长远发展提供决策支持与风险预警。',

      '分公司管理层由七十二位分公司老总组成，他们是各区域市场的直接负责人，负责将总部的战略意图转化为区域市场的具体行动，并确保各分公司在当地市场的合规运营与业务拓展。',

      '最一线的力量是有一百零八位核心团队长，他们是集团业务执行的中坚力量，直接带领团队服务客户、执行策略、反馈市场信息。一百零八位团队长构成了集团与客户之间最直接的连接纽带，也是集团服务质量与市场口碑的最终保障。',

      '蚂蚁链控股集团主席兼首席执行官白子晨表示：「这套组织架构是我们经过多年实践打磨形成的『作战体系』。从总部的一个大脑，到五大区域的五只拳头，再到一百零八位一线团队长，每一个人都在量化金融这场长跑中扮演着不可替代的角色。我们希望通过这次组织架构的公开，让合作伙伴和投资者看到蚂蚁链控集团的系统化实力与长期主义的运营理念。」',

      '此次组织架构公开被市场分析人士解读为蚂蚁链控集团进入新一轮规模化扩张阶段的标志性动作。业内普遍认为，完善的层级架构与广泛的区域覆盖，将为蚂蚁链控集团在竞争激烈的量化金融领域建立显著的规模优势与网络效应。',
    ],
  },
  11: {
    id: 11, category: '公司新闻', date: '2026-07-05',
    title: '香港蚂蚁量化启动海外全球市场，迪拜与泰国双运营总部即将落成挂牌',
    excerpt: '集团正式进军海外市场，迪拜运营中心主体结构封顶、泰国运营中心即将挂牌，标志着蚂蚁链控集团全球化战略布局迈出关键一步。',
    image: 'https://readdy.ai/api/search-image?query=Global%20business%20expansion%20concept%20abstract%20world%20map%20with%20glowing%20connection%20nodes%20between%20Asia%20and%20Middle%20East%20dark%20navy%20background%20gold%20accents%20professional%20corporate%20dark%20fintech%20style%20no%20text&width=1200&height=600&seq=news-detail-11&orientation=landscape',
    author: '集团国际业务拓展部',
    authorTitle: '蚂蚁链控股集团',
    readTime: '6 分钟',
    tags: ['海外拓展', '迪拜', '泰国', '全球化', '东南亚市场', '中东市场'],
    body: [
      '2026年7月5日，香港——蚂蚁链控股集团今日宣布，正式启动海外全球市场战略，同步推进迪拜运营中心与泰国运营中心的建设落地。两个海外运营总部即将先后落成挂牌，标志着集团从深耕国内市场向全球化布局迈出了具有里程碑意义的关键一步。',

      '迪拜运营中心选址于迪拜核心商务区，周边汇集了众多国际金融机构与主权财富基金。该项目自2025年底破土动工以来，建设进度持续超前推进。目前主体结构已全面封顶，外立面幕墙安装进入收尾阶段，预计将于2026年第三季度正式挂牌运营。',

      'IMAGE:https://static.readdy.ai/image/feef753f1ed8344cc3f9a51076258ebd/844a1743c7849789e031ff643d8ef814.jpeg',

      '从施工现场可以看到，迪拜运营中心大楼主体结构气势恢宏，塔吊林立、施工有序，紫色品牌横幅与蓝色围挡上的合作标识格外醒目。该项目由国际知名建筑事务所DGM ARCHETYPE担纲设计，楼体采用现代化玻璃幕墙与金属线条相结合的建筑语言，落成后将成为该区域极具辨识度的地标性金融办公建筑。',

      'IMAGE:https://static.readdy.ai/image/feef753f1ed8344cc3f9a51076258ebd/a108d08c72ea83893da20aa2d5a6ed3b.jpeg',

      '集团国际业务拓展部负责人介绍说，迪拜运营中心将承担中东及北非区域的市场开发、客户服务与合规运营职能，同时作为连接欧洲、非洲与亚洲资本市场的战略枢纽。中心正式运营后，将优先布局跨境量化交易、家族财富管理与离岸资产管理三大业务线，充分利用迪拜作为国际金融中心在资本流动、税务架构与监管环境方面的综合优势。',

      '与此同时，集团东南亚战略布局也在紧锣密鼓地推进中。泰国运营中心选址于曼谷核心商业区，依托泰国作为东盟门户的区位优势，辐射整个东南亚市场。目前办公大楼已完成精装修，品牌标识安装在即，挂牌仪式预计与迪拜运营中心同期举行。',

      'IMAGE:https://static.readdy.ai/image/feef753f1ed8344cc3f9a51076258ebd/8e1cc34705859f803c805a7670960bd3.jpeg',

      '泰国运营中心所在的办公楼外观现代大气，全玻璃幕墙在黄昏的光线下呈现出通透的蓝绿色调。中心落成后，将重点服务泰国本地高净值客户及在泰华人企业家群体，同时通过曼谷辐射新加坡、马来西亚、越南、印尼等东盟核心市场，为区域投资者提供涵盖量化策略、资产配置与跨境投融资的一站式金融服务。',

      '蚂蚁链控股集团主席兼首席执行官白子晨表示：「从香港出发，走向全球，是蚂蚁链控集团自创立之初就确立的长期战略。迪拜和泰国双运营总部的同步落地，不是简单的业务复制，而是基于对中东与东南亚市场深刻洞察后的精准布局。迪拜连接的是全球资本与中东主权财富，泰国锚定的是东盟六亿人口的巨大增长潜力。两大中心一东一西，互为犄角，将为集团构建起一个横跨亚太、中东与全球的24小时服务网络。」',

      '据悉，两个海外运营中心在正式挂牌后，将与香港总部形成「三中心联动」的全球运营架构。香港总部继续发挥战略决策、产品研发与合规管控的核心职能；迪拜中心聚焦中东资本对接与离岸金融服务；泰国中心深耕东南亚市场开发与区域客户服务。三者通过统一的技术中台与数据中台实现实时协同，确保全球客户在任意时区、任意市场都能享受到蚂蚁链控集团标准化的专业服务。',

      '业内分析人士指出，蚂蚁链控集团选择迪拜与泰国作为全球化首站，体现了集团对全球资本流向与区域经济格局的精准判断。迪拜作为全球财富管理的离岸高地，汇聚了大量寻求多元化配置的国际资本；而东南亚则是全球增长最快的新兴市场之一，中产阶级崛起与金融科技渗透率提升为量化投资与财富管理创造了巨大需求空间。蚂蚁链控集团双总部布局的落子时机与选址逻辑，均展现出战略层面的深思熟虑。',

      '集团方面表示，随着迪拜与泰国运营中心的逐步成熟，后续还将审慎评估伦敦、新加坡及纽约等国际金融中心的市场机会，持续完善全球化网络布局。蚂蚁链控集团的愿景是成为全球量化金融领域最具竞争力的华人金融机构之一，以科技驱动金融创新，以专业赢得全球客户信赖。',
    ],
  },
};

function ShareButton({ icon, label, onClick }: { icon: string; label: string; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-1.5 px-3.5 py-2 rounded-lg border border-background-300/30 bg-background-100 text-foreground-500 hover:text-foreground-200 hover:border-accent-500/30 hover:bg-background-100/80 transition-all duration-200 cursor-pointer whitespace-nowrap"
    >
      <i className={`${icon} text-sm`}></i>
      <span className="text-xs font-medium">{label}</span>
    </button>
  );
}

export default function NewsDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [cmsArticle, setCmsArticle] = useState<Article | null>(null);
  const [cmsArticles, setCmsArticles] = useState<Article[] | null>(null);

  const fallbackArticle = id ? articles[Number(id)] : undefined;
  const article = cmsArticle || fallbackArticle;

  useEffect(() => {
    if (!id) return;
    let mounted = true;
    Promise.all([
      getPublicNewsDetail(Number(id)),
      getPublicNews(),
    ])
      .then(([detail, list]) => {
        if (!mounted) return;
        setCmsArticle(detail.item as Article);
        setCmsArticles(list.items as Article[]);
      })
      .catch(() => {
        if (!mounted) return;
        setCmsArticle(null);
        setCmsArticles(null);
      });
    return () => { mounted = false; };
  }, [id]);

  useEffect(() => {
    if (!article) return;
    document.title = `${article.title} - 蚂蚁链控股集团`;
  }, [article]);

  if (!article) {
    return (
      <div className="min-h-screen bg-background-50 flex items-center justify-center">
        <div className="text-center">
          <i className="ri-file-unknow-line text-5xl text-foreground-600 mb-4 block"></i>
          <h2 className="text-xl font-heading font-bold text-foreground-200 mb-2">文章未找到</h2>
          <p className="text-sm text-foreground-500 mb-6">该文章可能已被删除或链接无效</p>
          <Link
            to="/news"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 text-background-950 rounded-full text-sm font-bold hover:bg-accent-400 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            返回新闻列表
          </Link>
        </div>
      </div>
    );
  }

  const handleShare = (platform: string) => {
    const url = window.location.href;
    const text = article.title;
    let shareUrl = '';

    switch (platform) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
        break;
      case 'linkedin':
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        break;
      case 'wechat':
        break;
      case 'copy':
        navigator.clipboard.writeText(url).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const allArticles = cmsArticles?.length ? cmsArticles : Object.values(articles);
  const relatedArticles = allArticles.filter((a) => a.id !== article.id).slice(0, 3);

  const allIds = allArticles.map((a) => a.id).sort((a, b) => b - a);
  const currentIndex = allIds.indexOf(article.id);
  const prevId = currentIndex < allIds.length - 1 ? allIds[currentIndex + 1] : null;
  const nextId = currentIndex > 0 ? allIds[currentIndex - 1] : null;

  return (
    <div className="min-h-screen bg-background-50">
      {/* Hero Banner */}
      <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-b from-background-50/90 via-background-50/50 to-background-50"></div>
        </div>
        <div className="relative px-6 md:px-12 lg:px-20">
          <div className="max-w-[900px] mx-auto">
            {/* Breadcrumb */}
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-6">
              <Link to="/" className="hover:text-accent-400 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-[10px]"></i>
              <Link to="/news" className="hover:text-accent-400 transition-colors">新闻动态</Link>
              <i className="ri-arrow-right-s-line text-[10px]"></i>
              <span className="text-foreground-400 line-clamp-1">{article.title}</span>
            </nav>

            {/* Category + Date */}
            <div className="flex items-center gap-3 mb-4">
              <span className="px-2.5 py-1 bg-accent-500/10 backdrop-blur-sm rounded-full text-[10px] md:text-xs font-semibold text-accent-400 border border-accent-500/20">
                {article.category}
              </span>
              <span className="text-xs text-foreground-500">{article.date}</span>
              <span className="text-xs text-foreground-600">· 阅读约{article.readTime}</span>
            </div>

            {/* Title */}
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-6">
              {article.title}
            </h1>

            {/* Author */}
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full bg-accent-500/20 border border-accent-500/30 flex items-center justify-center">
                <i className="ri-user-line text-accent-400 text-sm"></i>
              </div>
              <div>
                <p className="text-sm text-foreground-200 font-medium">{article.author}</p>
                <p className="text-[11px] text-foreground-500">{article.authorTitle}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Article Body */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="px-6 md:px-12 lg:px-20">
          <div className="max-w-[900px] mx-auto">
            {/* Share bar - top */}
            <div className="flex flex-wrap items-center gap-2 mb-10 pb-8 border-b border-background-300/30">
              <span className="text-xs text-foreground-600 mr-1">分享：</span>
              <ShareButton icon="ri-twitter-x-line" label="Twitter" onClick={() => handleShare('twitter')} />
              <ShareButton icon="ri-linkedin-line" label="LinkedIn" onClick={() => handleShare('linkedin')} />
              <ShareButton icon="ri-wechat-line" label="微信" onClick={() => handleShare('wechat')} />
              <ShareButton
                icon={copied ? 'ri-check-line' : 'ri-link'}
                label={copied ? '已复制' : '复制链接'}
                onClick={() => handleShare('copy')}
              />
            </div>

            {/* Article content */}
            <article className="prose-custom">
              {article.body.map((paragraph, i) => {
                if (paragraph.startsWith('IMAGE:')) {
                  const imgSrc = paragraph.slice(6);
                  return (
                    <figure key={i} className="my-8 rounded-xl overflow-hidden border border-background-300/30 bg-background-100">
                      <img
                        src={imgSrc}
                        alt={article.title}
                        className="w-full"
                      />
                      <figcaption className="text-center text-xs text-foreground-500 py-3 border-t border-background-300/20">
                        新闻插图
                      </figcaption>
                    </figure>
                  );
                }
                return (
                  <p key={i} className="text-sm md:text-base text-foreground-300 leading-relaxed mb-5 font-light">
                    {paragraph}
                  </p>
                );
              })}
            </article>

            {/* Tags */}
            <div className="flex flex-wrap items-center gap-2 mt-10 pt-8 border-t border-background-300/30">
              {article.tags.map((tag) => (
                <span key={tag} className="px-3 py-1 bg-background-100 rounded-full text-[11px] text-foreground-500 border border-background-300/30">
                  #{tag}
                </span>
              ))}
            </div>

            {/* Share bar - bottom */}
            <div className="flex flex-wrap items-center gap-2 mt-8 pt-8 border-t border-background-300/30">
              <span className="text-xs text-foreground-600 mr-1">分享这篇文章：</span>
              <ShareButton icon="ri-twitter-x-line" label="Twitter" onClick={() => handleShare('twitter')} />
              <ShareButton icon="ri-linkedin-line" label="LinkedIn" onClick={() => handleShare('linkedin')} />
              <ShareButton icon="ri-wechat-line" label="微信" onClick={() => handleShare('wechat')} />
              <ShareButton
                icon={copied ? 'ri-check-line' : 'ri-link'}
                label={copied ? '已复制' : '复制链接'}
                onClick={() => handleShare('copy')}
              />
            </div>

            {/* Prev / Next navigation */}
            <div className="flex items-center justify-between mt-10 pt-8 border-t border-background-300/30">
              {prevId ? (
                <Link
                  to={`/news/${prevId}`}
                  className="group flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-400 transition-colors"
                >
                  <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-transform duration-200"></i>
                  <span className="hidden sm:inline">上一篇</span>
                </Link>
              ) : (
                <div></div>
              )}
              <Link
                to="/news"
                className="flex items-center gap-1.5 px-4 py-2 rounded-lg border border-background-300/30 text-xs text-foreground-500 hover:text-foreground-200 hover:border-accent-500/30 transition-all duration-200 whitespace-nowrap"
              >
                <i className="ri-list-check-2"></i>
                返回列表
              </Link>
              {nextId ? (
                <Link
                  to={`/news/${nextId}`}
                  className="group flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-400 transition-colors"
                >
                  <span className="hidden sm:inline">下一篇</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-200"></i>
                </Link>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Related Articles */}
      <section className="py-14 md:py-20 bg-background-100/50 border-t border-background-300/20">
        <div className="px-6 md:px-12 lg:px-20">
          <div className="max-w-[1200px] mx-auto">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-200">相关阅读</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {relatedArticles.map((related) => (
                <Link
                  key={related.id}
                  to={`/news/${related.id}`}
                  className="group bg-background-50 rounded-xl border border-background-300/30 overflow-hidden hover:border-accent-500/30 hover:-translate-y-1 transition-all duration-300"
                >
                  <div className="relative h-40 overflow-hidden">
                    <img
                      src={related.image}
                      alt={related.title}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                    <div className="absolute top-3 left-3">
                      <span className="px-2 py-0.5 bg-background-100/85 backdrop-blur-sm rounded-full text-[10px] font-semibold text-accent-400 border border-background-300/30">
                        {related.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4">
                    <p className="text-[10px] text-foreground-600 mb-1.5">{related.date}</p>
                    <h3 className="text-sm font-semibold text-foreground-200 leading-snug group-hover:text-accent-400 transition-colors duration-200 line-clamp-2">
                      {related.title}
                    </h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
